import { Component, ViewChild } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import {
    Category, Lessee, Income
} from '../../../../../_models';
import { LiveSearchSelectComponent } from '../../../../../shared/live-search-select';
import { DatePickerComponent } from '../../../../../shared/date-picker';

import { IncomeFormComponent } from '../income-form/income-form.component';

@Component({
    selector: 'app-income-edit',
    templateUrl: '../../common/form/form-new.component.html',
    styleUrls: ['../../common/form/form-new.component.scss']
})
export class IncomeEditComponent extends IncomeFormComponent {
    incomeId: number;
    formHeader = {
        icon: 'fa fa-money',
        text: 'EDITAR INGRESO'
    };
    curr = this.options['lessee'];

    constructor(
        private _fbEdit: FormBuilder,
        private _lesseeModelEdit: Lessee,
        private _routeEdit: ActivatedRoute,
        private _locationEdit: Location,
        private incomeEdit: Income,
        private routerEdit: Router,
        private _categoryIncomeEditModel: Category
    ) {
        super(_fbEdit,
            _locationEdit, routerEdit, _lesseeModelEdit, _categoryIncomeEditModel);
        this.incomeId = this._routeEdit.snapshot.params['id'];
        this.form.valueChanges.subscribe(formValue => {
            this.requests$ = this.incomeEdit.put(this.incomeId, this.body);
        });
        this.dataFetched = false;
        this.incomeEdit.get(this.incomeId).subscribe(income => {
            this.form.setValue(income.pick(this.form.value));
            this._lesseeModelEdit.make(income.type_data);
            this.form.controls.name.setValue(income.type_data);
            this._categoryIncomeEditModel.make(income.category);
            this.form.controls.category.setValue(income.category);
            this.selectTypeData.listing();
            this.selectCategory.listing();
            this.dobPicker.setDate(income.date);
            this.dataFetched = true;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/incomes/income-edit/income-edit.component.ts